import { getState } from 'codewonders-helpers';

export const token = getState('DEVELOP_TOKEN');
export const user_id = getState('DEVELOP_USER_ID');

const user_token = window.atob(
	getState('DEVELOP_USER') ? getState('DEVELOP_USER') : 'e30='
);
export const user_status = JSON.parse(user_token);
